<script setup>
import {computed} from 'vue'

import SiteTree from "@/common/site-tree/SiteTree.vue"
import PageEditorSiteTreePinBtn from "./PageEditorSiteTreePinBtn.vue"
import SiteTreeNavigationMenu from "@/common/site-tree/SiteTreeNavigationMenu.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const siteTreeId = computed(() => pageEditorStore.siteTreeId)
</script>

<template>
    <div class="border-bottom">
        <div class="text-center p-3">
            <SiteTreeNavigationMenu :site-tree-id="siteTreeId"/>
        </div>

        <SiteTree :site-tree-id="siteTreeId"/>

        <!--<div class="text-end">
            <PageEditorSiteTreePinBtn/>
        </div>-->
    </div>
</template>